import { useMutation } from "@tanstack/react-query";
import { getApiUrl, getUsersCsvExportPath } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";
import { JWT_KEY } from "Utils/AuthUtils";
import { getLocalStorageItem } from "Utils/Storage/LocalStorage/SecureLocalStorage";
import { format } from "date-fns";
import FileSaver from "file-saver";

const fetchUsersCsv = async () => {
  const route = `${getApiUrl()}${getUsersCsvExportPath()}`;
  const response = await fetch(route, {
    method: "GET",
    mode: "cors",
    headers: { Authorization: getLocalStorageItem(JWT_KEY) ?? "" },
  });

  // Without this a 4xx/5xx would resolve and save the error body as a .csv.
  if (!response.ok) {
    throw new Error(`Users export failed with status ${response.status}`);
  }

  return response;
};

export const useDownloadUsersExportMutation = () => {
  const { t } = useResource();

  return useMutation({
    mutationFn: async (fileNamePrefix: string) => {
      const response = await fetchUsersCsv();
      const blob = await response.blob();
      const fileName = `${fileNamePrefix}_${format(new Date(), "yyyy-MM-dd")}.csv`;
      FileSaver.saveAs(blob, fileName);
    },
    onError: () => toast.error(t(Resources.Common.DownloadError)),
  });
};
